export const blogLeadValues = {
  lead_type: 'Marketing',
  lead_source: '1-800Accountant',
  campaign: 'Blog Join Now',
  channel: 'Digital',
};

export const efLeadValues = {
  lead_type: 'Marketing',
  lead_source: '1-800Accountant',
  campaign: 'Entity Formation',
  channel: 'Digital',
};
